export const options: Highcharts.Options = {
    title:
    {
        text: '',
    },
    xAxis: {visible: false},
    yAxis: {visible: false},
    legend: {enabled: false},
    exporting: {enabled: false},
    credits: {enabled: false},
    chart:
    {
        type: 'bar',
        margin: 0,
        height: 24,
        backgroundColor: "transparent",
        borderColor: "transparent"
    },
    tooltip:
    {
        headerFormat: "",
        valueSuffix: '%',
        outside: true,
    },
    plotOptions:
    {
        bar:
        {
            stacking: 'percent',
            groupPadding: 0,
            pointPadding: 0,
            borderRadius: 4,
            borderColor: "transparent",
        },
    },
};